import { render, staticRenderFns } from "./PaidMessage.vue?vue&type=template&id=86c3f296&"
import script from "./PaidMessage.vue?vue&type=script&lang=js&"
export * from "./PaidMessage.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/youtube/yt-live-chat-paid-message-renderer.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports